import { render, staticRenderFns } from "./CreateTreatmentModal.vue?vue&type=template&id=7855309f&scoped=true"
import script from "./CreateTreatmentModal.vue?vue&type=script&lang=js"
export * from "./CreateTreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTreatmentModal.vue?vue&type=style&index=0&id=7855309f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7855309f",
  null
  
)

export default component.exports